import React, { useCallback, useEffect, useState, useRef } from "react";
import { SelectBox } from "devextreme-react/select-box";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json";
import { CheckBox } from 'devextreme-react/check-box';
import { List } from "devextreme-react/list";
import { Button } from 'devextreme-react/button';
import { ReactComponent as LoadingIcon } from "../../assets/loading-process.svg";
import { ReactComponent as PreProcessIcon } from "../../assets/pre-process.svg";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { connect } from "react-redux";
import { confirm } from "devextreme/ui/dialog";
import DetailTemplate from './DetailTemplate.js';
import DateBox from 'devextreme-react/date-box';
import { GridLayout } from "../../../common/GridLayout";
import { downloadReportFile } from "../../../common/Utils";
import {
  Column,
  DataGrid,
  FilterRow,
  HeaderFilter,
  FilterPanel,
  Sorting,
  Toolbar,
  Item,
  Export,
  Editing,
  Paging,
  Pager,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Lookup,
  MasterDetail,
  StateStoring
} from "devextreme-react/data-grid";
import { HubConnectionBuilder } from "@microsoft/signalr";
import Popup from 'devextreme-react/popup';
import { GetDatePartOnlyDiffFormat } from "../../../common/Utils.js";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
const LotSelectList = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  const chargeCodes = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
  const filterBuilderPopupPosition = {
    of: window,
    at: "top",
    my: "top",
    offset: { y: 10 },
  };
  var seedSourceData = ["Weyer Inv", "Cust Inv", "Cust Seed"];
  const [chargeCode, setChargeCode] = React.useState("A");
  const [date, setdate] = React.useState(new Date());
  const [lotSelectDateRequest, setLotSelectDateRequest] = useState({
    lotSelectDate: date,
  });
  const [currentLayout, setCurrentLayout] = useState("Default");

  const [isGetPreProcessReportPopupVisible, setIsGetPreProcessReportPopupVisible] = React.useState(false);
  const [isPreProcessReportInProgressPopupVisible, setIsPreProcessReportInProgressPopupVisible] = React.useState(false);
  const [generatedPreProcessReportFileName, setGeneratedPreProcessReportFileName] = React.useState("");

  const [isGetPostProcessReportPopupVisible, setIsGetPostProcessReportPopupVisible] = React.useState(false);
  const [isPostProcessReportInProgressPopupVisible, setIsPostProcessReportInProgressPopupVisible] = React.useState(false);
  const [generatedPostProcessReportFileName, setGeneratedPostProcessReportFileName] = React.useState("");


  const [isGetExportToExcelPopupVisible, setIsGetExportToExcelPopupVisible] = React.useState(false);
  const [isExportToExcelInProgressPopupVisible, setIsExportToExcelInProgressPopupVisible] = React.useState(false);
  const [generatedExportToExcelFileName, setGeneratedExportToExcelFileName] = React.useState("");

  const [connection, setConnection] = React.useState(null);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${window._env_.REACT_APP_APIS.substring(0, window._env_.REACT_APP_APIS.length - 4)}/hubs/report`)
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  useEffect(() => {

    if (connection) {
      connection
        .start()
        .then((result) => {
          console.log("Connected!");

          connection.on("ReceiveMessage", (message) => {

            if (message.message.includes("SOR0017")) {
              setGeneratedPreProcessReportFileName(message.message);
              setIsGetPreProcessReportPopupVisible(true);
              setIsPreProcessReportInProgressPopupVisible(false);
            }
            else if (message.message.includes("SOR0010")) {
              setGeneratedPostProcessReportFileName(message.message);
              setIsGetPostProcessReportPopupVisible(true);
              setIsPostProcessReportInProgressPopupVisible(false);
            }
            else if (message.message.includes("SOR0016")) {
              setGeneratedExportToExcelFileName(message.message);
              setIsGetExportToExcelPopupVisible(true);
              setIsExportToExcelInProgressPopupVisible(false);
            }
          });
        })
        .catch((e) => console.log("Connection failed: ", e));
    }
  }, [connection]);

  const downloadPreProcessReport = () => {

    downloadReportFile(generatedPreProcessReportFileName, accessToken);
  }

  const renderPreProcessReportPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Pre Process Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={closeGetPreProcessReportPopup}
          type="default"
          stylingMode="contained"
          text="Close" />
        <Button onClick={downloadPreProcessReport}
          type="default"
          stylingMode="contained"
          text="Download Report" />
      </div>
    )
  }

  const renderPreProcessReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Pre Process Report</h6>
        <p>Report generation is in progess ...</p>
        <Button onClick={closePreProcessReportInProgressPopup}
          type="default"
          stylingMode="contained"
          text="Close" />
      </div>
    )
  }

  const closeGetPreProcessReportPopup = () => {
    setIsGetPreProcessReportPopupVisible(false);
    setIsPreProcessReportInProgressPopupVisible(false);
  }

  const closePreProcessReportInProgressPopup = () => {

    setIsPreProcessReportInProgressPopupVisible(false);
  }

  const downloadPostProcessReport = () => {

    downloadReportFile(generatedPostProcessReportFileName, accessToken);
  }

  const renderPostProcessReportPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report has been generated Successfully Click View Report To See!.</p>
        <Button onClick={closeGetPostProcessReportPopup}
          stylingMode="contained"
          text="Close" />

        <Button onClick={downloadPostProcessReport}
          type="default"
          stylingMode="contained"
          text="Download Report" />
      </div>
    )
  }

  const renderPostProcessReportInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Report</h6>
        <p>Report generation is in progess ...</p>
        <Button onClick={closePostProcessReportInProgressPopup}
          type="default"
          stylingMode="contained"
          text="Close" />
      </div>
    )
  }

  const closeGetPostProcessReportPopup = () => {
    setIsGetPostProcessReportPopupVisible(false);
    setIsPostProcessReportInProgressPopupVisible(false);
  }

  const closePostProcessReportInProgressPopup = () => {

    setIsPostProcessReportInProgressPopupVisible(false);
  }


  const downloadExportToExcel = () => {

    downloadReportFile(generatedExportToExcelFileName, accessToken);
  }

  const renderExportToExcelPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Excel</h6>
        <p>Excel has been generated Successfully Click View Report To See!.</p>
        <Button onClick={closeGetExportToExcelPopup}
          stylingMode="contained"
          text="Close" />
        <Button onClick={downloadExportToExcel} type="default"
          stylingMode="contained"
          text="Download Report" />
      </div>
    )
  }

  const renderExportToExcelInProgressPopup = () => {
    return (
      <div>
        <h6 style={{ color: "#76b4ea" }}>Generate Excel</h6>
        <p>Excel generation is in progess ...</p>
        <Button type="default" stylingMode="contained" onClick={closeExportToExcelInProgressPopup}>
          Close
        </Button>
      </div>
    )
  }

  const closeGetExportToExcelPopup = () => {
    setIsGetExportToExcelPopupVisible(false);
    setIsExportToExcelInProgressPopupVisible(false);
  }

  const closeExportToExcelInProgressPopup = () => {

    setIsExportToExcelInProgressPopupVisible(false);
  }

  const exportFile = (e) => {
    var report = new Object();
    report.Name = "SOR0017";
    report.IgnoreFormat = true;

    axios.post
      (
        `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
        report,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          }
        }
      )
      .then((res) => {
        if (window._env_.Generate_Report_From_Remote) {
          if (res.data.isSuccess) {
            setIsGetPreProcessReportPopupVisible(false);
            setIsPreProcessReportInProgressPopupVisible(true);
          }
          else {
            alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
          }

        }
        else {
          if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
            if (res.data.isSuccess) {
              downloadReportFile(res.data.fileName, accessToken);
            }
            else {
              alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
            }
          }
          else {
            alert("Cannot generate report", "Error");
          }
        }
      })
      .catch((err) => {
        alert(err, "Error");
      });

  };

  const [processOrderRequest, setProcessOrderRequest] = useState({
    rowId: "",
    chkLotSelectRpt: false,
    lotSelectExcel: false,
  });
  const onProcssOrder = () => {
    let result = confirm("<i>Process Lot Selected?</i>", "Process Order");
    result.then((dialogResult) => {
      if (dialogResult) {
        dataGrid.current.instance().beginCustomLoading("Processing");
        axios
          .post(
            `${window._env_.REACT_APP_APIS}/${routes.pu_processing.ProcessOrders}`,
            null,
            {
              headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
              },
            }
          )
          .then((res) => {
            const reportTasks = [];

            if (processOrderRequest.chkLotSelectRpt) {
              if (lotSelectDateRequest.lotSelectDate) {
                var report = new Object();
                report.Name = "SOR0010";
                report.IgnoreFormat = true;
                var whereInfo = new Object();
                whereInfo.FieldType = 4; //ParameterTypeEnum.DateTime;
                whereInfo.FieldName = "LotSelectDate";
                whereInfo.Operation = 3; //OperationEnum.Equal
                whereInfo.Origin = "SOMASTERDATABASE.LOTSELECTDATE";
                whereInfo.From = GetDatePartOnlyDiffFormat(lotSelectDateRequest.lotSelectDate, "/");
                report.FilterWhereInfoList = [];
                report.FilterWhereInfoList.push(whereInfo);
                reportTasks.push(axios.post
                  (
                    `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
                    report,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                      },
                    }
                  ).then((res) => {
                    if (window._env_.Generate_Report_From_Remote) {
                      if (res.data.isSuccess) {
                        setIsGetPostProcessReportPopupVisible(false);
                        setIsPostProcessReportInProgressPopupVisible(true);
                      }
                      else {
                        alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                      }

                    }
                    else {
                      if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
                        if (res.data.isSuccess) {
                          // Returned so the loading stays up until the file has downloaded.
                          return downloadReportFile(res.data.fileName, accessToken);
                        }
                        else {
                          alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                        }
                      }
                      else {
                        alert("Cannot generate report", "Error");
                      }
                    }
                  })
                  .catch((err) => {
                    console.log(err, "Error in Printing lot select list report.");
                  }));
              }
              else {
                alert("Please select date!");
              }
            }

            if (processOrderRequest.lotSelectExcel) {
              if (lotSelectDateRequest.lotSelectDate) {
                var report = new Object();
                report.Name = "SOR0016";
                report.IgnoreFormat = true;
                report.FileFormat = "XLSX";
                var whereInfo = new Object();
                whereInfo.FieldType = 4; //ParameterTypeEnum.DateTime;
                whereInfo.FieldName = "LotSelectDate";
                whereInfo.Operation = 3; //OperationEnum.Equal
                whereInfo.Origin = "SOMASTERDATABASE.LOTSELECTDATE";
                whereInfo.From = GetDatePartOnlyDiffFormat(lotSelectDateRequest.lotSelectDate, "/");
                report.FilterWhereInfoList = [];
                report.FilterWhereInfoList.push(whereInfo);
                reportTasks.push(axios.post
                  (
                    `${window._env_.REACT_APP_APIS}/${routes.reports.GenerateReport}`,
                    report,
                    {
                      headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                      },
                    }
                  ).then((res) => {
                    if (window._env_.Generate_Report_From_Remote) {
                      if (res.data.isSuccess) {
                        setIsGetExportToExcelPopupVisible(false);
                        setIsExportToExcelInProgressPopupVisible(true);
                      }
                      else {
                        alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                      }

                    }
                    else {
                      if (res.hasOwnProperty('data') && res.data != null && res.data != undefined) {
                        if (res.data.isSuccess) {
                          // Returned so the loading stays up until the file has downloaded.
                          return downloadReportFile(res.data.fileName, accessToken);
                        }
                        else {
                          alert("Cannot generate report. Error:  " + res.data.errorMessage, "Error");
                        }
                      }
                      else {
                        alert("Cannot generate report", "Error");
                      }
                    }
                  })
                  .catch((err) => {
                    console.log(err, "Error in exporting lot select list report. ");
                  }));
              }
              else {
                alert("Please select date!");
              }
            }

            // The loading stays up until the reports have been generated and downloaded.
            return Promise.all(reportTasks).then(() => {
              dataGrid.current.instance().endCustomLoading();
              dataGrid.current.instance().refresh();
            });
          })
          .catch((err) => {
            dataGrid.current.instance().endCustomLoading();
            alert(err, "Error");
          });
      }
    });
  };

  const handleChangeForPrintReport = (e) => {
    setProcessOrderRequest({
      ...processOrderRequest,
      ["chkLotSelectRpt"]: e.value,
    });
  };
  const handleChangeForExcelExport = (e) => {
    setProcessOrderRequest({
      ...processOrderRequest,
      ["lotSelectExcel"]: e.value,
    });
  };

  const warehouseDataSource = () => {
    return createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetWarehouses}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  };

  const onContentReady = (e) => {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", createStore({
        key: "masterrowid",
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.pu_processing.FetchLotsToSelect}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${routes.pu_processing.UpdateLotSelect}`,
        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        },
      })
      );
    }
  };

  const setIsLotSelectValue = (newData, value, currentRowData) => {
    var rowIndex = dataGrid.current.instance().getRowIndexByKey(currentRowData.masterrowid);

    if (value) {
      dataGrid.current.instance().cellValue(
        rowIndex,
        "lotselectdate",
        date
      );

      dataGrid.current.instance().cellValue(
        rowIndex,
        "chargecode",
        chargeCode
      );
    }
    else {
      dataGrid.current.instance().cellValue(rowIndex, "lotselectdate", "");
      dataGrid.current.instance().cellValue(rowIndex, "chargecode", "");
    }

    dataGrid.current.instance().saveEditData();
  };

  const setWarehouseValue = (newData, value) => {
    newData.seeditem = null;
    newData.seedlot = null;
    newData.location = null;
    newData.rseedinventory = null;
    newData.germ = null;
    newData.purity = null;
    newData.seedslb = null;
    newData.warehouse = value;
  };

  const setSeedItemValue = (newData, value) => {
    newData.seedlot = null;
    newData.location = null;
    newData.rseedinventory = null;
    newData.germ = null;
    newData.purity = null;
    newData.seedslb = null;
    newData.seeditem = value;
  };

  const setSeedLotValue = (newData, value) => {
    newData.location = null;
    newData.rseedinventory = null;
    newData.germ = null;
    newData.purity = null;
    newData.seedslb = null;
    newData.pounds = null;
    newData.bags = null;
    newData.seedlot = value;
  };

  const getSeedInventory = (location, currentData) => {
    return axios.get
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedInventoryInfo}?itemCode=${currentData.speciescode}&warehouse=${currentData.warehouse}&seedItem=${currentData.seeditem}&seedLot=${currentData.seedlot}&location=${location}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken
          },
        }
      )
      .then(res => {
        return res.data;
      })
      .catch(error => { throw "Data Loading Error" });
  };

  const setLocationValue = (newData, value, currentData) => {
    return getSeedInventory(value, currentData).then(data => {
      newData.location = value;
      newData.rseedinventory = data.rowid;
      newData.germ = data.germ;
      newData.purity = data.purity;
      newData.seedslb = data.seedslb;
    });
  };

  const seedItemDataSource = (options) => {

    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedItems}`,
        loadParams:
        {
          masterRowId: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.masterrowid != null && options.data.masterrowid != undefined) {
                  return options.data.masterrowid;
                }
              }
            }
            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.speciescode != null && options.data.speciescode != undefined) {
                  return options.data.speciescode;
                }
              }
            }
            return "";

          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }
            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  };

  const seedLotDataSource = (options) => {
    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetSeedLots}`,
        loadParams:
        {
          masterRowId: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.masterrowid != null && options.data.masterrowid != undefined) {
                  return options.data.masterrowid;
                }
              }
            }
            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.speciescode != null && options.data.speciescode != undefined) {
                  return options.data.speciescode;
                }
              }
            }
            return "";

          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          },
          seedLot: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seedlot != null && options.data.seedlot != undefined) {
              return options.data.seedlot;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  };

  const locationDataSource = (options) => {

    return {
      store: createStore({
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetLocations}`,
        loadParams:
        {
          masterRowId: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.masterrowid != null && options.data.masterrowid != undefined) {
                  return options.data.masterrowid;
                }
              }
            }
            return "00000000-0000-0000-0000-000000000000";
          },
          itemCode: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.speciescode != null && options.data.speciescode != undefined) {
                  return options.data.speciescode;
                }
              }
            }
            return "";

          },
          warehouse: function () {
            if (options != null && options != undefined) {
              if (options.hasOwnProperty('data')) {
                if (options.data != null && options.data != undefined &&
                  options.data.warehouse != null && options.data.warehouse != undefined) {
                  return options.data.warehouse;
                }

                return "";
              }
            }

            return undefined;
          },
          seedItem: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seeditem != null && options.data.seeditem != undefined) {
              return options.data.seeditem;
            }

            return "";
          },
          seedLot: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.seedlot != null && options.data.seedlot != undefined) {
              return options.data.seedlot;
            }

            return "";
          },
          location: function () {
            if (options != null && options != undefined &&
              options.hasOwnProperty('data') && options.data != null && options.data != undefined &&
              options.data.location != null && options.data.location != undefined) {
              return options.data.location;
            }

            return "";
          }
        },

        onBeforeSend: function (method, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${accessToken}`
          };
        }
      }),
    };
  };
  const itemRender = (itemData) => {
    if (itemData.type === 'checkbox') {
      return (
        <CheckBox
          onValueChanged={itemData.onValueChanged}
          value={itemData.value}
          text={itemData.text}
        />
      );
    }
    if (itemData.type === 'button') {
      return (
        <Button type="default"
          stylingMode="contained"
          onClick={(e) => onProcssOrder(e)}
          text="Process Order" />
      )
    }
  }

  const allowedPageSizes = [10, 100, 200, 500, "all"];
  const gridKey = "c9e1c3dc-723a-4dc5-85da-cd7ba1b351a3";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  const items = [
    { type: 'checkbox', onValueChanged: handleChangeForPrintReport, value: processOrderRequest.chkLotSelectRpt, text: "Print Report" },
    { type: 'checkbox', onValueChanged: handleChangeForExcelExport, value: processOrderRequest.lotSelectExcel, text: "Export To Excel" },
    { type: 'button' }
  ];

  return (
    <div style={{ height: "calc(100vh - 95px)" }}>
      <div className="title">
        <h6
          style={{
            color: window._env_.Color2
          }}
        >
          Select Lots To Assign
        </h6>
      </div>
      <div className="cardWrapper">
        <div className="row bg-color">
          <div className="col-md-6" style={{ marginTop: "0px", marginBottom: "25px" }}>
            <div className="row">
              <div className="col-md-6">
                <span>Charge Code</span>
                <SelectBox
                  placeholder="Charge Code"
                  items={chargeCodes}
                  defaultValue={chargeCodes[0]}
                  onValueChanged={(e) => setChargeCode(e.value)}
                />
              </div>
              <div className="col-md-6">
                <span>Date</span>
                <DateBox
                  type="date"
                  placeholder="Date"
                  value={date}
                  onValueChanged={(e) => setdate(e.value)}
                />
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <Button type="default"
              stylingMode="contained"
              style={{ marginTop: '16px' }}
              onClick={(e) => exportFile(e)}
              text="Pre Process Report" />
          </div>
          <div className="col-md-3 right-card-wrapper">
            <div className="right-card">
              <List items={items} itemRender={itemRender} />
            </div>
          </div>
        </div>
      </div>

      <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
        id="gridContainer"
        onContentReady={(e) => onContentReady(e)}
        ref={dataGrid}
        showBorders={true}
        className="GridHeightLotSelectScreen"
        keyExpr="masterrowid"
        rowAlternationEnabled={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnAutoWidth={true}
      >
        <Paging defaultPageSize={100} />
        <Pager
          visible={true}
          showPageSizeSelector={true}
          allowedPageSizes={allowedPageSizes}
          showNavigationButtons={true}
          showInfo={true}
        />
        <FilterRow visible={true} />
        <FilterPanel visible={true} />
        <FilterBuilderPopup position={filterBuilderPopupPosition} />
        <ColumnChooser
          enabled={true}
          title="Choose Column"
          width={290}
          height={290}
          sortOrder="asc"
        >
          <ColumnChooserSearch
            enabled={true}
            editorOptions={{ placeholder: 'Search column' }} />
        </ColumnChooser>
        <HeaderFilter visible={true} />
        <ColumnFixing enabled={true} />,
        <Export enabled={true} allowExportSelectedData={true} text="Export" />
        <Sorting mode="multiple" />
        <Editing
          mode="cell"
          refreshMode="reshape"
          allowUpdating={true}
          allowAdding={false}
          allowDeleting={false}
        />
        <StateStoring
          enabled={true}
          type="custom"
          customLoad={loadState}
          storageKey={gridKey}
          customSave={saveState}
        />
        <Column
          dataField="islotselect"
          dataType="boolean"
          caption=""
          setCellValue={(newData, value, currentRowData) => setIsLotSelectValue(newData, value, currentRowData)}
        />
        <Column
          dataField="chargecode"
          caption=""
          allowEditing={false}
        />
        <Column
          dataField="lotselectdate"
          dataType="date"
          caption="Assigned"
          allowEditing={false}
          minWidth={100}
        />
        <Column
          dataField="stratdate"
          dataType="date"
          caption="Strat Date"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="species"
          caption="Species"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="celltype"
          caption="Stock"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="oversow"
          caption="Oversow"
          width={100}
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="prodlot"
          caption="Production Lot"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="rep"
          caption="SLM"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="salesitem"
          caption="Seed Item"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="orderquantity"
          dataType="number"
          caption="Order Qty"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="salesorderline"
          caption="Order # - Line"
          allowEditing={false}
          cssClass="column-readonly"
        />
        <Column
          dataField="comment"
          caption="Comment"
          allowEditing={false}
          cssClass="column-readonly"
        />

        <MasterDetail
          enabled={true}
          remoteOperations={true}
          component={DetailTemplate}
        />
        <Toolbar>
          <Item location="after">
            <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
          </Item>
          <Item name="exportButton" />
          <Item name="columnChooserButton" />
        </Toolbar>
      </DataGrid>
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Report!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isGetPreProcessReportPopupVisible}
        contentRender={renderPreProcessReportPopup}
      />
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Report!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isPreProcessReportInProgressPopupVisible}
        contentRender={renderPreProcessReportInProgressPopup}
      />
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Report!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isGetPostProcessReportPopupVisible}
        contentRender={renderPostProcessReportPopup}
      />
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Report!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isPostProcessReportInProgressPopupVisible}
        contentRender={renderPostProcessReportInProgressPopup}
      />
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Excel!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isGetExportToExcelPopupVisible}
        contentRender={renderExportToExcelPopup}
      />
      <Popup
        width={450}
        height={160}
        showTitle={false}
        title="Generate Excel!"
        dragEnabled={false}
        hideOnOutsideClick={true}
        visible={isExportToExcelInProgressPopupVisible}
        contentRender={renderExportToExcelInProgressPopup}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(LotSelectList);

